import axios from "axios";
import { centralizedHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { ModuleFields } from "~/Utils/drilldownData";

export interface OptionType {
  label: string;
  value: string;
}
export type AsyncSelectField = ModuleFields & {
  loadOptions?: () => Promise<OptionType[]>;
};

export const fetchDataAndTransform = async (
  url: string,
  labelKey: string,
  valueKey?: string,
  filterFn?: (item: any) => boolean
): Promise<OptionType[]> => {
  try {
    const res = await axios.get(`${centralizedHost}${url}`);
    if (res?.data) {
      const filteredData = res.data.filter((item: any) => {
        if (!item.published) return false;
        return filterFn ? filterFn(item) : true;
      });

      return filteredData.map((item: any) => ({
        label: decodeHTML(item[labelKey]),
        value: valueKey ? decodeHTML(String(item[valueKey])) : decodeHTML(item[labelKey]),
      }));
    }
    return [];
  } catch (err) {
    console.error("Error fetching data:", err);
    return [];
  }
};

export const fetchKeyInfoListOptions = () => fetchDataAndTransform("/api/key-info-group/all-fields", "title", "id");
